import React from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';

const styles = {
    rowHeight: {height: '40px'},
    columnSmall: {paddingLeft: 10, paddingRight: 10},
};

const TransferAuditTableRow = ({data}) => (
    <TableRow style={styles.rowHeight}>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.product_unit}
        </TableRowColumn>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.product_unit_name}
        </TableRowColumn>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.original_qty}
        </TableRowColumn>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.counted}
        </TableRowColumn>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.discrepancy}
        </TableRowColumn>
        <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
            {data.collection_id}
        </TableRowColumn>
    </TableRow>
);

TransferAuditTableRow.propTypes = {
    data: PropTypes.object.isRequired,
};

TransferAuditTableRow.defaultProps = {
    style: {padding: 0},
};

export default TransferAuditTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransferAuditTableRow.js